// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editBtn[data-v-750cbf72]{text-align:center;border-color:#f18b62!important;color:#f18b62!important;border-style:dashed}.w-500-oa[data-v-750cbf72]{width:500px;overflow:auto}", ""]);
// Exports
module.exports = exports;
